import { createSelector } from 'reselect';

const getState = (state) => state.errorHandler;

const getIsOpened = createSelector(getState, (state) => state.show);

const getTitle = createSelector(getState, (state) => state.title);

const getDescription = createSelector(getState, (state) => state.description);

export { getIsOpened, getTitle, getDescription };
